import {
  SET_OBSTACLE_ID,
  SET_OBSTACLE_NAME,
  SET_OBSTACLE_GEOJSON,
  SET_OBSTACLE_GEOHASH,
  OBSTACLES_RECEIVED,
  SET_OBSTACLE_GROUNDRISK,
  SET_OBSTACLE_CELL_ID,
  CLEAR_OBSTACLE_STATE
} from 'actions/actionTypes';

const defaultState = {
  list: [],
  id: '',
  name: '',
  groundRisk: '',
  geoJson: {},
  cellId: 2
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case OBSTACLES_RECEIVED:
      return {
        ...state,
        list: action.payload
      };
    case SET_OBSTACLE_ID:
      return {
        ...state,
        id: action.payload
      };
    case SET_OBSTACLE_NAME:
      return {
        ...state,
        name: action.payload
      };
    case SET_OBSTACLE_GEOJSON:
      return {
        ...state,
        geoJson: action.payload
      };
    case SET_OBSTACLE_GEOHASH:
      return {
        ...state,
        geoHash: action.payload
      };
    case SET_OBSTACLE_GROUNDRISK:
      return {
        ...state,
        groundRisk: action.payload
      };
    case SET_OBSTACLE_CELL_ID:
      return {
        ...state,
        cellId: action.payload
      };
    case CLEAR_OBSTACLE_STATE:
      return {
        ...state,
        ...defaultState
      };
    default:
      return state;
  }
};

export const selectObstacles = state => state.obstacles.list;
export const selectObstacleId = state => state.obstacles.id;
export const selectObstacleName = state => state.obstacles.name;
export const selectObstacleGeoJson = state => state.obstacles.geoJson;
export const selectObstacleGeoHash = state => state.obstacles.geoHash;
export const selectObstacleGroundRisk = state => state.obstacles.groundRisk;
export const selectObstacleCellId = state => state.obstacles.cellId;
